<div class="page-area">
    <div class="basic-boxes">
        <div class="basic-details basic-details2">
            <div class="basic-title">
                <h5>Manual Punch</h5>
            </div>
            <div class="basic-contbox">
                <div class="emp-box">
                    <div class="basic-cont">
                        <div class="emp-title">
                            <h5>Leave From</h5>
                        </div>
                        <div class="emp-input">
                            <nz-date-picker [(ngModel)]="date" (ngModelChange)="onChange($event)"></nz-date-picker>
                        </div>
                    </div>
                    <div class="basic-cont">
                        <div class="emp-title">
                            <h5>Leave To</h5>
                        </div>
                        <div class="emp-input">
                            <nz-date-picker [(ngModel)]="date" (ngModelChange)="onChange($event)"></nz-date-picker>
                        </div>
                    </div>
                </div>
                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Punch ID</h5>
                    </div>
                    <div class="emp-input">
                        <input nz-input placeholder="Punch ID" [(ngModel)]="value" />
                    </div>
                </div>
                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Employee</h5>
                    </div>
                    <div class="emp-input">
                        <input nz-input placeholder="Employee" [(ngModel)]="value" />
                    </div>
                </div>

                <div class="leave-entry">
                    <nz-radio-group [(ngModel)]="radioValue">
                        <label nz-radio nzValue="A">PL - Paid Leave (Paid)</label>
                        <label nz-radio nzValue="B">CL - Causual Leave (Unpaid)</label>
                        <label nz-radio nzValue="C">LWP - Leave without pay (Unpaid)</label>
                        <label nz-radio nzValue="D">OD - Outdoor Duty (Paid)</label>
                    </nz-radio-group>
                </div>

                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Employee</h5>
                    </div>
                    <div class="emp-input">
                        <textarea nz-input placeholder="Employee" nzAutosize></textarea>
                    </div>
                </div>


                <div class="grace-btnbox">
                    <ul>
                        <li>
                            <a href="javascript:void(0);">
                                <span><i nz-icon nzType="search" nzTheme="outline"></i></span>
                                Search
                            </a>
                        </li>
                        <li>
                            <a href="javascript:void(0);">
                                <span><i nz-icon nzType="clear" nzTheme="outline"></i></span>
                                Clear
                            </a>
                        </li>
                        <li>
                            <a href="javascript:void(0);">
                                <i nz-icon nzType="printer" nzTheme="outline"></i>
                                Print
                            </a>
                        </li>
                        <li>
                            <a href="javascript:void(0);">
                                <i nz-icon nzType="close-circle" nzTheme="outline"></i>
                                Close
                            </a>
                        </li>
                    </ul>
                </div>

                <div class="manual-list">
                    <ul>
                        <li>
                            <span>Leave in year</span>
                            <span><strong>: 12</strong></span>
                        </li>
                        <li>
                            <span>Used Leave</span>
                            <span><strong>: 3</strong></span>
                        </li>
                        <li>
                            <span>Available</span>
                            <span><Strong>: 9</Strong></span>
                        </li>
                    </ul>
                </div>


            </div>
        </div>

        <div class="basic-details basic-details3">
            <div class="tabledata">
                <!-- <div class="tabletop-description">
                    <div class="t-description">
                        <h5>Main Department</h5>
                        <a href="#">Print & Export</a>
                    </div>
                </div> -->
                <nz-table #fixedTable [nzData]="listOfData2" [nzSize]="'small'">
                    <thead>
                        <tr>
                            <th>Leave Date</th>
                            <th>Leave Type</th>
                            <th>Remark</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of fixedTable.data">
                            <td>{{ data.name }}</td>
                            <td>{{ data.age }}</td>
                            <td>{{ data.address }}</td>
                            <td><i nz-icon nzType="delete" nzTheme="outline"></i></td>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
        </div>
    </div>
</div>